<template>
  <div>
    <v-row style="height: 0;">
      <v-col offset="6" cols="6">
        <div class="gr-action d-flex justify-end">
          <div class="box-product-type">
            <v-select
              class="v-select-mini mr-5"
              :items="categories"
              item-value="id"
              item-text="name"
              :aLight="'right'"
              placeholder="Chọn"
              attach
              outlined
              dense
              @change="getData(searchParams.status)"
              v-model="searchParams.root_category_id"
              :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
            ></v-select>
          </div>

          <v-menu
            :internal-activator="true"
            content-class="menu__custom no-contain overflow-visible"
            :close-on-content-click="false"
            style="z-index: 10"
          >
            <template v-slot:activator="menuON">
              <v-tooltip bottom style="z-index: 10;">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="btn-search"
                    small
                    v-on="menuON.on"
                  >
                    <v-icon color="white" v-on="on">
                      mdi-magnify-plus-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>Tìm kiếm</span>
              </v-tooltip>
            </template>
            <v-card class="mx-auto overflow-visible px-6" width="600px" style="margin-top: 0px; margin-bottom: 0px;z-index: 99" outlined>
              <v-row>
                <v-col class="text-center text-bold" cols="12">
                  <span style="font-size: 18px;">Tìm kiếm</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" style="padding:0px 12px !important">
                  <p class="text-bold mb-1">Loại sản phẩm</p>
                  <v-autocomplete
                    class="text-field"
                    :clearable="true"
                    :items="productAttributes.productType"
                    item-value="id"
                    item-text="name"
                    attach
                    outlined
                    dense
                    placeholder="Chọn loại sản phẩm"
                    v-model="searchParams.type"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" style="padding:0px 12px !important">
                  <p class="text-bold mb-1">Mã sản phẩm</p>
                  <v-text-field
                    class="text-field"
                    :clearable="true"
                    outlined
                    dense
                    v-model="searchParams.code"
                    placeholder="Nhập mã Sản phẩm"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" style="padding:0px 12px !important">
                  <p class="text-bold mb-1">Mã SKU</p>
                  <v-text-field
                    class="text-field"
                    :clearable="true"
                    outlined
                    dense
                    v-model="searchParams.sku_code"
                    placeholder="Nhập mã SKU"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" style="padding:0px 12px !important">
                  <p class="text-bold mb-1">Tên sản phẩm</p>
                  <v-text-field
                    class="text-field"
                    :clearable="true"
                    outlined
                    dense
                    v-model="searchParams.name"
                    placeholder="Nhập tên sản phẩm"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" style="padding:0px 12px !important">
                  <p class="text-bold mb-1">Tên SKU</p>
                  <v-text-field
                    class="text-field"
                    :clearable="true"
                    outlined
                    dense
                    v-model="searchParams.sku_name"
                    placeholder="Nhập tên SKU"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="6">
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Danh mục"
                    placeholder="Chọn Danh mục"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Trạng thái"
                    placeholder="Chọn trạng thái"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Môn"
                    placeholder="Chọn môn"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </v-col>
              </v-row> -->
              <!-- <v-row>
                <v-col cols="6">
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Loại sản phẩm"
                    placeholder="Gia sư"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Chương trình"
                    placeholder="Chọn chương trình"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </v-col>
              </v-row> -->
              <!-- <v-row>
                <v-col cols="6">
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Lộ trình"
                    placeholder="Chọn lộ trình"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Số buổi"
                    placeholder="Chọn số buổi"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </v-col>
              </v-row> -->
              <!-- <v-row>
                <v-col cols="6">
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Loại giáo viên"
                    placeholder="Chọn loại giáo viên"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    :clearable="true"
                    :items="[]"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    label="Loại lớp"
                    placeholder="Chọn loại lớp"
                    attach
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                  ></v-select>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col class="text-center" cols="12">
                  <v-btn
                    class="btn-search"
                    @click="getData(searchParams.status)"
                  >
                    Tìm kiếm
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-menu>

          <v-btn
            v-if="checkAuthorization('oms-product_create')"
            class="btn-create-product"
            small
            @click="createProduct()"
          >
            Thêm sản phẩm
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-tabs v-model="tab" slider-color="yellow">
      <v-tabs-slider color="#FF7A00"></v-tabs-slider>
      <v-tab @click="getData()">Tất cả</v-tab>
      <v-tab @click="getData('active')">Đang hoạt động</v-tab>
      <v-tab @click="getData('inactive')">Ngừng hoạt động</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <ListProduct v-if="productAttributes" :productAttributes="productAttributes" :isLoading="isLoading" :data="listData" />
      </v-tab-item>
      <v-tab-item>
        <ListProduct v-if="productAttributes" :productAttributes="productAttributes" :isLoading="isLoading" :data="listData" />
      </v-tab-item>
      <v-tab-item>
        <ListProduct v-if="productAttributes" :productAttributes="productAttributes" :isLoading="isLoading" :data="listData" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

import ListProduct from './components/ListProduct.vue';

export default {
  components: {
    ListProduct,
  },
  data() {
    return {
      tab: 1,
      item: null,
      listData: [],
      searchParams: {
        root_category_id: null,
        status: 'active',
        code: null,
        name: null,
        sku_name: null,
        sku_code: null,
        type: null,
      },
      categories: [],
      isLoading: false,
      productAttributes: null,
    };
  },
  computed: {
  },
  async created() {
    this.getListAttributes();
    this.getCategories();

  },
  beforeDestroy() {
  },
  methods: {
    async getData(status = null) {
      this.listData = [];
      if (!this.searchParams.root_category_id) {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Chưa chọn danh mục!',
        });
        return;
      }
      this.isLoading = true;
      for (let key in this.searchParams) {
        if (typeof this.searchParams[key] === 'string' && this.searchParams[key].trim() === '') {
          this.searchParams[key] = null;
        }
      } 
      let params = {
        root_category_id: this.searchParams.root_category_id,
        code: this.searchParams.code,
        name: this.searchParams.name,
        sku_name: this.searchParams.sku_name,
        sku_code: this.searchParams.sku_code,
        type: this.searchParams.type,
      };
      if (status) {
        this.searchParams.status = status;
        params = {
          status: status,
          root_category_id: this.searchParams.root_category_id,
          code: this.searchParams.code,
          name: this.searchParams.name,
          sku_name: this.searchParams.sku_name,
          sku_code: this.searchParams.sku_code,
          type: this.searchParams.type,
        };
      }

      if (!status) {
        this.searchParams.status = null;
        delete params.status;
      }

      const res = await ProductRepository.list(params);
      this.listData = res.data;
      this.isLoading = false;
    },

    async getListAttributes() {
      const res = await ProductRepository.getProductAttributes();
      this.productAttributes = res.data;
    },

    async getCategories() {
      const res = await ProductRepository.getCategories({is_parent: true});
      this.rootCategoryId = res.data[0].id;
      this.searchParams.root_category_id = res.data[0].id;
      this.categories = res.data;
      this.getData(this.searchParams.status);
    },

    createProduct() {
      this.$router.push('/products/create')
    },
  },
  watch: {
    // currentPage: {
    //   handler() {
    //     this.addHashToLocation( {...this.filterForm, page: this.currentPage });
    //     this.getList();
    //   }
    // },
  }
};
</script>
<style scoped lang="scss">
.text-bold {
  font-weight: bold;
}
.gr-action {
  position: relative;
  top: 0px;
  z-index: 10;

  .btn-search {
    background: #508D13 !important;
    min-width: 50px;
    color: #fff;
  }

  .btn-create-product {
    background: #6587FF !important;
    color: #fff;
  }
}
.menu__custom {
  top: calc(20% - 75px) !important;
  left: 96% !important;
  transform: translateX(-96%) !important;
}
.btn-search {
  background: #6587FF !important;
}

.box-product-type {
  width: 200px;
}
</style>

<style lang="scss">
.v-select-mini {
  .v-input__slot {
    min-height: 28px !important;
    height: 28px;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__append-inner {
    margin-top: 3px !important;
  }
}

.v-tab--active {
  color: #5E64FF !important;
}
.v-tabs-slider-wrapper {
  .v-tabs-slider {
    background-color: #5E64FF !important;
  }
}
</style>
